<template>
<div style="height: 100%;">
    <div class="handleBox flex flex-ai-c">
        <el-page-header @back="goBack" content="赠送订单 — 详情"></el-page-header>
    </div>

    <div class="ddDetBox">
        <el-row>
            <el-col :span="24">
                <el-card class="box-card" body-style="ppading:'0'">
                    <div slot="header" class="clearfix">
                        <span>订单基本信息</span>
                        <el-button style="float: right; padding: 3px 0" type="text">订单编号：{{formData.order_num}}
                        </el-button>
                    </div>
                    <div class="infoBox">
                        <el-descriptions class="margin-top" title="" :column="4" border>
                            <el-descriptions-item label-class-name="my-content" label="赠送昵称">{{formData.user_nickname}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="my-content" label="优惠抵扣">{{formData.xiao_fei_jin}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="my-content" label="礼包抵扣">{{formData.li_bao}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="my-content" label="贡献值抵扣">{{formData.jin_dou}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="my-content" label="赠送方式">{{formData.give_type == 1 ? '单独送礼' : '群送礼'}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="my-content" label="应付金额(元)">{{formData.amount_payable}}</el-descriptions-item>
                            <el-descriptions-item label-class-name="my-content" label="实付金额(元)">{{formData.amount}}</el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>

    <el-card class="never giftList" style="margin-top: 10px;height: calc(100% - 265px);">
        <div slot="header" class="clearfix">
            <span>赠送商品信息</span>
        </div>
        <div class="table receive_people" style="height:calc( 100% - 60px );margin-top: 0;box-shadow:none;padding: 0;">
            <el-table ref="multipleTable" :data="formData.details" stripe height="calc( 100% - 40px )" :header-cell-style="{background:'#f5f7fa',color:'#909399'}">
                <el-table-column prop="main_pic" label="商品图片" width="150px" align="center">
                    <template slot-scope="scope">
                        <el-image v-if="scope.row.goods_pic" class="main_pic" style="width: 80px; height: 80px" :src="getImgUrl(scope.row.goods_pic)" fit="cover" :preview-src-list="[domain + '/' + scope.row.goods_pic]">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline" style="font-size:70px"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="goods_name" label="商品标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="scpecs_name" label="规格" width="150px" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="price" label="单价" width="150px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="received_total" label="领取数量" width="150px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="number" label="数量" width="150px" show-overflow-tooltip></el-table-column>
                <el-table-column label="领取详情" width='700px' show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-for="(item,index) in scope.row.receive_user" :key="index" class="flex flex-ai-c flex-jc-sb receive_border">
                            <div style="margin-right: 60px;width: 300px;">
                                <div>昵称：{{item.nickname}}</div>
                                <div>姓名：{{item.receive.name}}</div>
                                <div>电话：{{item.receive.mobile}}</div>
                                <div>地址：{{item.receive.address}}</div>
                            </div>
                            <div style="margin-right: 60px;width: 200px;">
                                <div>快递公司：{{item.receive.express_name ? item.receive.express_name : '暂无'}}</div>
                                <div>快递单号：{{item.receive.express_num ? item.receive.express_num : '暂无'}}</div>
                            </div>
                            <el-button-group>
                                <el-button type="primary" v-if="item.receive.status_id == 2" size="mini" @click="deliverGoods(item.receive,1)">发货</el-button>
                                <el-button type="primary" v-else size="mini" :disabled="true">{{item.receive.status_text}}</el-button>
                            </el-button-group>
                        </div>
                        <div v-if="scope.row.receive_user.length == 0">礼物暂未领取</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-card>

    <el-dialog :title="title" :visible.sync="deliverVisible" :modal-append-to-body="false" :close-on-click-modal="false" width="600px">
        <el-form ref="formAuth" :rules="formRules" :model="fahuoData" label-position="top" size="small" class="alertForm">
            <el-form-item label="快递公司" style="width:100%;margin:0" prop="express_name">
                <el-select v-model="fahuoData.express_name" placeholder="请选择快递公司">
                    <el-option v-for="val in kdList" :key="val" :label="val" :value="val"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="快递单号" style="width:100%" prop="express_num">
                <el-input v-model="fahuoData.express_num" placeholder="请输入快递单号"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="deliverVisible=false">取 消</el-button>
            <el-button size="small" type="primary" @click="deliverSubmit()">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
export default {
    data() {
        return {
            formData: {},
            kdList: [], //快递列表
            fahuoData: {},
            formRules: {
                express_name: [{
                    required: true,
                    message: '请选择快递公司',
                    trigger: 'change'
                }],
                express_num: [{
                    required: true,
                    message: '请输入快递单号',
                    trigger: 'change'
                }],
            },
            title: '填写物流信息',
            state: 1,

            deliverVisible: false,

        }
    },
    mounted() {
        this.read();
        this.getKdList(); //快递列表
    },
    methods: {
        //快递名称列表
        getKdList() {
            this.http.post('/admin/order/getExpressSelect').then(re => {
                this.kdList = re;
            });
        },
        //详情
        read: function() {
            this.http.post('/admin/receive/getOrder', {
                order_id: this.$route.query.id
            }).then(response => {
                this.formData = response;
            })
        },

        // 图片转换
        getImgUrl(item) {
            return this.domain + '/' + item;
        },

        deliverGoods: function(row) {
            // console.log(row)
            this.deliverVisible = true;
            // this.state = state; //判断为填写物流or修改物流
            // this.title = state == 1 ? '填写物流信息' : '修改物流信息';
            this.fahuoData = {
                id: row.id,
                express_name: row.express_name,
                express_num: row.express_num
            }
        },
        //物流提交
        deliverSubmit: function() {
            this.$refs['formAuth'].validate((valid) => {
                if(valid) {
                    // let url = this.state == 1 ? '/admin/order/fahuo' : '/admin/order/updateFahuo';
                    this.http.post('/admin/receive/fahuo', this.fahuoData).then(() => {
                        this.deliverVisible = false;
                        this.$message({
                            message: '已提交',
                            type: 'success'
                        });
                        this.read();
                    });
                }
            })

        },

        //返回
        goBack: function() {
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="less" >
.my-label {
    width: 200px;
}

.receive_people {
    .el-table .cell.el-tooltip {
        white-space: inherit !important;
    }
}

.ddDetBox {
    .el-card__body {
        padding: 0;
    }

    .el-card__header {
        border-bottom: 0;
    }

    .el-card__body {
        padding: 0;
    }

    .infoBox {
        padding: 0 20px 10px;
        box-sizing: border-box;

    }
}

.giftList {
    .el-card__body {
        height: 100%;
    }

    .receive_border {
        border-bottom: 1px dashed #F1F1F1;
        padding: 8px 0;
    }

    .receive_border:last-child {
        border-bottom: none;
    }
}
.my-content {
    width: 130px;
}
</style>
